import { gql } from '@apollo/client/core';

export const GET_CATEGORIES = gql`
    query GetCategories($documentId: ID, $page: Int!, $pageSize: Int!) {
        categories_connection(
            filters: { tournament: { documentId: { eq: $documentId } } }
            pagination: { page: $page, pageSize: $pageSize }
            sort: ["createdAt:desc"]
        ) {
            nodes {
                documentId
                name
                num_award
                num_player
                start_date
                end_date
                note
                age
                description
                type
                tour_matches {
                    documentId
                    tour_match_status
                }
            }
            pageInfo {
                page
                pageCount
                pageSize
                total
            }
        }
    }
`;